import { useRef, useState } from 'react';
import Title from '../../../../components/dialog/title';
import TrackerItem from './trackerItem';
import CardioItem from './cardioItem';
import SportsItem from './sportsItem';
import HiitItem from './hiitItem';
import ChallengeItem from './challengeItem';
import ProgramRoutineItem from './programRoutineItem';
import Menu from './menu';
import EditLog from '../edit';

const TrackerView = ({
  dialogRef,
  closeDialog,
  selectedDate,
  openCreateDialog,
  refreshWorkoutTracker,
  workoutTrackers,
  refreshWorkoutTrackerLog,
  preference,
  user,
}) => {
  const menuRef = useRef(null);
  const editDialogRef = useRef(null);

  const [selectedId, setSelectedId] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [editOpen, setEditOpen] = useState(false);

  const handleClose = () => {
    refreshWorkoutTracker();
    closeDialog();
  };

  const openMenu = (id, type) => () => {
    if (menuRef.current) {
      setSelectedId(id);
      setSelectedType(type);
      menuRef.current.showModal();
    }
  };

  const closeMenu = () => {
    if (menuRef.current) {
      menuRef.current.close();
      setSelectedId(null);
      setSelectedType(null);
    }
  };

  const openEditDialog = () => {
    if (selectedType === 'CHALLENGE' || selectedType === 'PROGRAM') {
      return alert(`${selectedType} log data is not allowed to change`);
    }
    if (editDialogRef.current) {
      editDialogRef.current.showModal();
      setEditOpen(true);
    }
  };

  const closeEditDialog = () => {
    if (editDialogRef.current) {
      editDialogRef.current.close();
      setEditOpen(false);
      closeMenu();
    }
  };

  return (
    <dialog
      ref={dialogRef}
      className='p-4 w-full h-full max-w-lg max-h-full bg-primary'
    >
      <div className='flex flex-col h-full'>
        <Title
          title={`${selectedDate} workout`}
          onClick={handleClose}
          color='white'
        />
        <div className='flex flex-col flex-1 overflow-hidden'>
          <div className='flex-1 overflow-y-auto scrollbar-hidden space-y-4 rounded-xl'>
            {workoutTrackers.map((workoutTracker) =>
              workoutTracker.type === 'CARDIO' ? (
                <CardioItem
                  key={workoutTracker.id}
                  workoutTracker={workoutTracker}
                  openMenu={openMenu(workoutTracker.id, workoutTracker.type)}
                />
              ) : workoutTracker.type === 'HIIT' ? (
                <HiitItem
                  key={workoutTracker.id}
                  workoutTracker={workoutTracker}
                  openMenu={openMenu(workoutTracker.id, workoutTracker.type)}
                  preference={preference}
                />
              ) : ['SPORTS', 'STRETCHING'].includes(workoutTracker.type) ? (
                <SportsItem
                  key={workoutTracker.id}
                  workoutTracker={workoutTracker}
                  openMenu={openMenu(workoutTracker.id, workoutTracker.type)}
                />
              ) : workoutTracker.type === 'CHALLENGE' ? (
                <ChallengeItem
                  key={workoutTracker.id}
                  workoutTracker={workoutTracker}
                  openMenu={openMenu(workoutTracker.id, workoutTracker.type)}
                  preference={preference}
                />
              ) : workoutTracker.type === 'PROGRAM' ? (
                <ProgramRoutineItem
                  key={workoutTracker.id}
                  workoutTracker={workoutTracker}
                  openMenu={openMenu(workoutTracker.id, workoutTracker.type)}
                  preference={preference}
                />
              ) : (
                <TrackerItem
                  key={workoutTracker.id}
                  workoutTracker={workoutTracker}
                  openMenu={openMenu(workoutTracker.id, workoutTracker.type)}
                  preference={preference}
                />
              )
            )}
          </div>
          <div className='flex-shrink-0 pt-4'>
            <button
              className='bg-accent rounded-full p-2 w-full font-bold'
              onClick={openCreateDialog}
            >
              New
            </button>
          </div>
        </div>
      </div>
      <Menu
        dialogRef={menuRef}
        closeDialog={closeMenu}
        selectedId={selectedId}
        getWorkoutTracker={refreshWorkoutTrackerLog}
        openEditDialog={openEditDialog}
      />
      <EditLog
        dialogRef={editDialogRef}
        closeDialog={closeEditDialog}
        refreshWorkoutTracker={refreshWorkoutTrackerLog}
        selectedId={selectedId}
        preference={preference}
        user={user}
        editOpen={editOpen}
      />
    </dialog>
  );
};

export default TrackerView;
